export default [{
    header: 'Encuestas',
    icon: 'MessageSquareIcon',
    children: [{
            title: 'Lista',
            route: 'surveys',
            icon: 'ListIcon'
        }
    ]
}];